<p-toast position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6">
        <lib-page-header page-title="GRUPOS DE SERVIÇOS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} "
          image-title="assets/img/stock.png">
        </lib-page-header>
      </div>
      <div class="col-md-6">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="podeIncluir()" [routerLink]="['/grupos-servico/novo']"
          class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-1" />
    <div class="row mt-2">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" style="width: 10%" class="text-center">Código</th>
              <th scope="col" style="width: 50%">Nome</th>
              <th scope="col" style="width: 50%">Sub-Grupo</th>
              <th scope="col" style="width: 90px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <th scope="row" class="text-center">
                {{item.sub_grupo.grupo.codigo}}.{{item.sub_grupo.codigo}}.{{item.codigo}}
              </th>
              <td>
                {{item.nome}}
                <span *ngIf="item.bec" class="badge badge-primary ml-2">Bec</span>
                <span *ngIf="item.servico" class="badge badge-success ml-2">Serviço</span>
                <span *ngIf="item.contabilizar" class="badge badge-warning ml-2">Contabilizar</span>
              </td>
              <td>{{item.sub_grupo.nome}}</td>
              <td class="text-right" style="min-width: 100px;">
                <button [routerLink]="['/grupos-servico', item.id, 'visualizar']" routerLinkActive="router-link-active"
                  *ngIf="!podeIncluir()" class="btn btn-sm btn-outline-secondary mr-2" title="Visualizar">
                  <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                </button>
                <button [routerLink]="['/grupos-servico', item.id, 'editar']" routerLinkActive="router-link-active"
                  *ngIf="podeIncluir()" class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>